// client/src/coms/views/canvas_parts/party/PartyArcadeView.js
// Games on the stand-alone Canvas page (/canvas?arcade=1, ?party=, ?partyCode=, ?partyResult=) and over a
// canvas room: the same Games hub as the Voxemera shell, showing the drawing games when a canvas opened it.
import React, { useEffect, useState } from 'react';
import GamesHub from '../../games_parts/GamesHub';

function setUrlParams(params) {
  if (typeof window === 'undefined' || !window.history || !window.history.replaceState) return;
  const url = new URL(window.location.href);
  ['party', 'partyCode', 'partyResult', 'arcade'].forEach((key) => url.searchParams.delete(key));
  Object.entries(params).forEach(([key, value]) => {
    if (value) url.searchParams.set(key, value);
  });
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

export default function PartyArcadeView({ user, canvasId = 0, initial = {}, syncUrl = false, onClose }) {
  const [start] = useState(() => ({ sessionId: initial.sessionId || '', code: initial.code || '', resultId: initial.resultId || '' }));

  // Invitation links are used once; the page keeps showing the arcade.
  useEffect(() => {
    if (syncUrl) setUrlParams({ arcade: '1' });
  }, [syncUrl]);

  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', minHeight: 0 }} data-testid="party-root">
      <GamesHub user={user} canvasId={canvasId} drawingOnly={Boolean(canvasId)} initial={start} onClose={onClose} />
    </div>
  );
}
